import React from 'react';
import {Alert, AlertProps, IconButton, styled} from '@mui/material';
import {designSystemToken, Icon, Label} from '@lightricks/react-design-system';

const StyledAlert = styled(Alert)(() => ({
  'width': '100%',
  'height': '20px',
  'borderRadius': '12px',
  'padding': '6px 0px 6px 16px',
  'alignItems': 'center',
  '& .MuiAlert-action': {
    padding: 0,
    marginLeft: '8px',
  },
  '& .MuiIconButton-root': {
    padding: '1px',
  },
}));

interface DismissibleAlertProps {
  severity: AlertProps['severity'];
  title: string;
  onClose?: () => void;
}

function DismissibleAlert({onClose, title, severity}: DismissibleAlertProps) {
  return (
    <StyledAlert
      severity={severity}
      icon={
        <Icon
          name="Actions-Info-Line"
          size="medium"
          appearance="neutral"
          color={designSystemToken('reference.purple.60')}
        />
      }
      action={
        onClose && (
          <IconButton
            onClick={onClose}
            aria-label="Close Alert"
            sx={{
              color: designSystemToken('action.active'),
              opacity: 0.56,
            }}
          >
            <Icon
              name="Actions-Close-Small"
              size="medium"
              appearance="neutral"
            />
          </IconButton>
        )
      }
    >
      <Label
        size="lg"
        sx={{
          fontWeight: 700,
          letterSpacing: '0.15px',
        }}
      >
        {title}
      </Label>
    </StyledAlert>
  );
}

export default DismissibleAlert;
